'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CalendarOutlined = _interopRequireDefault(require('./lib/icons/CalendarOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _CalendarOutlined;
exports.default = _default;
module.exports = _default;